import { AxiosResponse } from 'axios'
import axiosApi from '../api/axios-api'

export default {
	employeeView(id: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/employee/view/` + id, null)
				.then(function(response) {
					resolve(response);
				})
				.catch(function(error) {
					reject(error);
				});
		});
	},
	employeeUpdatePassword(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/employee/update/password`, request)
				.then(function(response) {
					resolve(response);
				})
				.catch(function(error) {
					reject(error);
				});
		});
	},
	employeeList(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/employee/list`, request)
				.then(function(response) {
					resolve(response);
				})
				.catch(function(error) {
					reject(error);
				});
		});
	},
}
